import { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./global.css";
import AppProviders from "./providers/ContextProviders";
import AppRoutes from "./routes";
import DeviceGuard from "./DeviceGuard";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Fragment>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppProviders>
        <DeviceGuard>
          <AppRoutes />
        </DeviceGuard>
      </AppProviders>
    </BrowserRouter>
  </Fragment>
);
